const tichengPage = () => import('@/views/main/performance-commission/ticheng/ticheng.vue')
export default {
  path: '/main/tichengPage',
  name: 'tichengPage',
  component: tichengPage,
  children: []
}
